import Checkbox from '@mui/material/Checkbox'
import FormControl from '@mui/material/FormControl'
import FormGroup from '@mui/material/FormGroup'
import React from 'react'

import { capitalizeFirstLetter } from '@/app/module/campaigns/helpers'

import { SpacingContainer, StyledFormControlLabel } from './common'

export type Props = {
  selectedAnswers: string[]
  validAnswers: string[]
  onAnswersChange: (answers: string[]) => void
}

const CatiAnswerMultiple: React.FC<Props> = ({ selectedAnswers, validAnswers, onAnswersChange }) => {
  const toggleAnswer = (answer: string) => {
    if (selectedAnswers.includes(answer)) {
      onAnswersChange(selectedAnswers.filter((a) => a !== answer))
    } else {
      onAnswersChange([...(selectedAnswers || []), answer])
    }
  }

  return (
    <SpacingContainer spacing={2}>
      <FormControl fullWidth variant="standard">
        <FormGroup sx={{ width: '100%' }}>
          {validAnswers.map((answer) => (
            <StyledFormControlLabel
              key={answer}
              control={<Checkbox checked={!!selectedAnswers?.includes(answer)} onChange={() => toggleAnswer(answer)} />}
              label={capitalizeFirstLetter(answer)}
            />
          ))}
        </FormGroup>
      </FormControl>
    </SpacingContainer>
  )
}

export default CatiAnswerMultiple
